import React from 'react';
import PropTypes from 'prop-types';
import './style';

const SidebarItem = ({ label, icon, onClick, isSelected, colorMode }) => {
  return (
    <div className={`sidebar-item ${isSelected ? 'selected' :'' } ${colorMode === 'black' ? 'color-black' : '' }`} 
      onClick={onClick}>
      {icon && <div className='icon'>{icon}</div>}
      {label}
    </div>
  );
};

SidebarItem.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.node,
  onClick: PropTypes.func.isRequired,
  isSelected:PropTypes.bool.isRequired,
  colorMode: PropTypes.oneOf(['black', 'grey-to-black']),
};

SidebarItem.defaultProps = {
  icon: null,
  isSelected:false,
  colorMode: 'grey-to-black',
};

export default SidebarItem;